import { Box, Typography, Stack, Pagination } from "@mui/material";

/**
 * Component to display user's daily streak with pagination
 * @param {Object} props
 * @param {number} props.currentStreak - The current streak day count
 * @param {number} props.totalDays - The total possible days for streak
 * @param {string} props.timeRemaining - Time remaining string for the current streak
 */
export default function DailyStreak({
  currentStreak = 5,
  totalDays = 7,
  timeRemaining = "2 days, 3 hours, 15 minutes",
}) {
  return (
    <Box
      sx={{
        mt: 3,
        p: 2,
        borderRadius: 2,
        bgcolor: "background.neutral",
        boxShadow: "0 4px 12px 0 rgba(0,0,0,0.08)",
        position: "relative",
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "5px",
          background:
            "linear-gradient(90deg, #0088FE 0%, #00C49F 25%, #FFBB28 50%, #FF8042 75%, #0088FE 100%)",
        }}
      />
      <Stack
        direction={{ xs: "column", sm: "row" }}
        spacing={2}
        alignItems="center"
        justifyContent="space-between"
      >
        <Box>
          <Typography variant="subtitle1" sx={{ fontWeight: "bold", mb: 0.5 }}>
            Daily Streak
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Ends At: {timeRemaining}
          </Typography>
        </Box>
        <Pagination
          count={totalDays}
          hidePrevButton
          hideNextButton
          defaultPage={totalDays}
          page={currentStreak}
          disabled={false}
          sx={{
            "& .MuiPaginationItem-root": {
              borderRadius: "50%",
              minWidth: 36,
              height: 36,
              margin: "0 4px",
              "&.Mui-selected": {
                bgcolor: "primary.main",
                color: "primary.contrastText",
                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.15)",
                fontWeight: "bold",
                "&:hover": {
                  bgcolor: "primary.dark",
                },
              },
              "&:not(.Mui-selected)": {
                bgcolor: "background.paper",
                border: "1px solid",
                borderColor: "divider",
              },
            },
          }}
        />
      </Stack>
    </Box>
  );
}
